import type { ModuleFoldersStructureData } from "@scayla/api-client-fetch";
import { moduleFoldersStructure } from "@scayla/api-client-fetch";
import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";

import { useWorkspace } from "@/store/workspace";

export function getModuleFoldersStructureQuery(
  moduleId: string,
  options: { withTemplates?: boolean; forSetting?: boolean } = { withTemplates: true, forSetting: false },
) {
  const workspace = useWorkspace();

  return {
    queryKey: [
      "moduleFoldersStructure",
      moduleId,
      workspace.tenantId,
      workspace.orgId ?? undefined,
      options.withTemplates,
      options.forSetting,
    ],
    queryFn: async () => {
      const params = {
        path: { moduleId },
        body: {
          tenantId: workspace.tenantId,
          organizationId: workspace.orgId ?? undefined,
          withTemplates: options.withTemplates,
          templateParams: {
            tenantId: workspace.tenantId,
            organizationId: workspace.orgId ?? undefined,
            moduleId,
          },
          forSetting: options.forSetting,
        },
      } as ModuleFoldersStructureData;
      const result = await moduleFoldersStructure(params);
      if (result.error) {
        throw new Error(result.error.message);
      }

      return result.data;
    },
    enabled: !!moduleId && !!workspace.tenantId,
  };
}

export function useModuleFoldersStructure(
  moduleId: string,
  options: { withTemplates?: boolean; forSetting?: boolean } = { withTemplates: true, forSetting: false },
  extraOptions: { enabled?: boolean } = {},
) {
  const queryConfig = getModuleFoldersStructureQuery(moduleId, options);
  return useQuery({
    ...queryConfig,
    enabled: computed(() => queryConfig.enabled && (extraOptions.enabled ?? true)),
  });
}
